function initCredentialsCarousel(root) {
  if (!root || typeof Swiper === 'undefined') return;

  const swiperEl = root.querySelector('.credentials-carousel__media-swiper');
  const paginationEl = root.querySelector('[data-credentials-pagination]');
  const quoteEl = root.querySelector('[data-credentials-quote]');
  const sourceEl = root.querySelector('[data-credentials-source]');
  const slideData = Array.from(root.querySelectorAll('.credentials-carousel__slide-data'));

  if (!swiperEl || !quoteEl || !sourceEl || !slideData.length) return;

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  if (window.innerWidth > 768) return;

  function setActiveBullet(index) {
    paginationEl?.querySelectorAll('.credentials-carousel__bullet').forEach((bullet, i) => {
      bullet.classList.toggle('credentials-carousel__bullet--active', i === index);
    });
  }

  function updatePanel(index) {
    const data = slideData[index];
    if (!data) return;

    quoteEl.textContent = data.dataset.quote || '';
    sourceEl.textContent = '';

    const sourceLabel = data.dataset.sourceLabel || '';
    if (sourceLabel) {
      sourceEl.append(document.createTextNode(sourceLabel));
    }

    const footnote = data.dataset.footnote || '';
    if (footnote) {
      const footnoteEl = document.createElement('span');
      footnoteEl.className = 'credentials-carousel__source-footnote';
      footnoteEl.textContent = footnote;
      sourceEl.append(footnoteEl);
    }

    const cardBg = data.dataset.cardBg;
    if (cardBg) {
      quoteEl.closest('.credentials-carousel__quote-box')?.style.setProperty('--credentials-card-bg-mb', cardBg);
    }

    setActiveBullet(index);
  }

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: slideData.length > 2,
    on: {
      init: function () {
        updatePanel(this.activeIndex);
      },
      slideChange: function () {
        updatePanel(this.activeIndex);
      },
    },
  });

  root._credentialsSwiper = swiper;

  if (!root.dataset.credentialsClickBound) {
    root.dataset.credentialsClickBound = 'true';
    root.addEventListener('click', (event) => {
      const bullet = event.target.closest('.credentials-carousel__bullet');
      if (!bullet || !root._credentialsSwiper) return;
      const index = Number.parseInt(bullet.dataset.index, 10);
      if (Number.isNaN(index)) return;
      root._credentialsSwiper.slideTo(index);
    });
  }
}

function initAllCredentialsCarousels(scope) {
  (scope || document).querySelectorAll('[data-credentials-carousel]').forEach(initCredentialsCarousel);
}

document.addEventListener('DOMContentLoaded', () => initAllCredentialsCarousels());

document.addEventListener('shopify:section:load', (event) => {
  initAllCredentialsCarousels(event.target);
});

let credentialsResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(credentialsResizeTimer);
  credentialsResizeTimer = setTimeout(() => initAllCredentialsCarousels(), 150);
});
